import React from "react";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";
import { isColor, isMono, isPhoto } from "../log/logLabels";

const incomeTypes = [
  { name: "Хар цагаан", color: "#475569" },
  { name: "Өнгөт", color: "#7C3AED" },
  { name: "Зураг", color: "#10B981" },
];

const incomeType = (amount) => {
  if (isPhoto(amount)) return "Зураг";
  if (isMono(amount.color_type)) return "Хар цагаан";
  if (isColor(amount.color_type)) return "Өнгөт";
  return "Бусад";
};

const PrinterIncome = ({ printerData }) => {
  if (!printerData || printerData.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-center">
        <div className="flex items-center justify-center w-12 h-12 mb-3 text-xl text-gray-400 bg-gray-100 rounded-full dark:bg-gray-700">₮</div>
        <p className="font-medium text-gray-600 dark:text-gray-300">Орлогын мэдээлэл алга</p>
        <p className="mt-1 text-sm text-gray-400">Сонгосон хугацаанд гүйлгээ бүртгэгдээгүй байна.</p>
      </div>
    );
  }

  const printers = printerData
    .map((item) => ({
      ...item,
      income: (item.totalAmount || []).reduce(
        (sum, amount) => sum + Number(amount.totalAmount || 0),
        0
      ),
    }))
    .sort((a, b) => b.income - a.income);
  const types = printers.some((item) =>
    (item.totalAmount || []).some((amount) => incomeType(amount) === "Бусад")
  )
    ? [...incomeTypes, { name: "Бусад", color: "#F59E0B" }]
    : incomeTypes;
  const categories = printers.map(
    (item) => `${item.printerDetails?.name || "Принтер"} · ${item.printerDetails?.location || "-"}`
  );
  const series = types.map(({ name }) => ({
    name,
    data: printers.map((item) =>
      (item.totalAmount || [])
        .filter((total) => incomeType(total) === name)
        .reduce((sum, total) => sum + Number(total.totalAmount || 0), 0)
    ),
  }));

  const options = {
    chart: { type: "bar", stacked: true, toolbar: { show: false }, fontFamily: "Inter, sans-serif" },
    plotOptions: { bar: { horizontal: false, borderRadius: 4, columnWidth: "52%" } },
    grid: { borderColor: "#E5E7EB", strokeDashArray: 4 },
    xaxis: { categories, labels: { rotate: -30, trim: true, style: { colors: "#6B7280" } } },
    yaxis: { labels: { formatter: (value) => new Intl.NumberFormat("mn-MN", { notation: "compact" }).format(value) } },
    tooltip: { y: { formatter: (value) => `${new Intl.NumberFormat("mn-MN").format(value)} ₮` } },
    legend: { position: "top", horizontalAlign: "right", markers: { radius: 4 } },
    dataLabels: { enabled: false },
    colors: types.map(({ color }) => color),
    responsive: [{ breakpoint: 640, options: { chart: { height: 320 }, legend: { position: "bottom" }, plotOptions: { bar: { columnWidth: "70%" } } } }],
  };

  return <Chart options={options} series={series} type="bar" height={360} />;
};

PrinterIncome.propTypes = { printerData: PropTypes.array };
PrinterIncome.defaultProps = { printerData: [] };

export default PrinterIncome;
